import React, { Component, Fragment } from 'react'
import Tab from './Tab'
import Info from './Info'
import Table from './Table'
import { inject } from 'mobx-react'

@inject('listStore')
export default class extends Component {
  componentDidMount() {
    this.props.listStore.getCount()
  }
  render() {
    const { listStore } = this.props
    return (
      <Fragment>
        <Info store={listStore} />
        <Tab store={listStore} />
        <Table store={listStore} />
      </Fragment>
    )
  }
}
